// Shared print/download helpers for QR code labels (QRCodeField, QRCodeLabel).

export const printQrLabel = (dataUrl, text) => {
  // NOTE: do not add 'noopener' to the features string — it makes window.open
  // return null, so the popup could never be written to (Print was a silent
  // no-op). Safe here: the popup is about:blank populated only by our own code
  // (static shell + .textContent + a locally generated data-URL image), with no
  // third-party content.
  const w = window.open('', '_blank', 'width=400,height=520');
  if (!w) return; // popup blocked

  // Static, non-interpolated shell only — `text` (which may originate from a
  // scanned QR code, i.e. attacker-controlled text) is never concatenated into
  // markup. It's inserted below via .textContent, never .innerHTML.
  w.document.write(
    '<html><head><title>QR Code</title></head>' +
    '<body style="display:flex;flex-direction:column;align-items:center;font-family:monospace;padding-top:24px;"></body></html>'
  );
  w.document.close();

  const img = w.document.createElement('img');
  img.style.width = '260px';
  img.style.height = '260px';
  // Print only once the image has loaded; handler set before src is assigned.
  img.onload = () => {
    w.focus();
    w.print();
  };
  img.src = dataUrl; // set as a property, not a string-built attribute
  w.document.body.appendChild(img);

  const p = w.document.createElement('p');
  p.textContent = text; // text only — never parsed as markup
  w.document.body.appendChild(p);
};

export const downloadQrLabel = (dataUrl, name) => {
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = `${name || 'qr'}.png`;
  a.click();
};

export const printQrLabelBatch = (items) => {
  // items: [{ dataUrl, text }, ...]
  if (!items.length) return true; // nothing to print — treat as a no-op success

  const w = window.open('', '_blank', 'width=800,height=600');
  if (!w) return false; // popup blocked

  w.document.write(
    '<html><head><title>QR Codes</title></head>' +
    '<body style="display:flex;flex-wrap:wrap;gap:16px;font-family:monospace;padding:24px;"></body></html>'
  );
  w.document.close();

  let loaded = 0;
  items.forEach(({ dataUrl, text }) => {
    const cell = w.document.createElement('div');
    cell.style.cssText = 'display:flex;flex-direction:column;align-items:center;width:140px;';

    const img = w.document.createElement('img');
    img.style.width = '120px';
    img.style.height = '120px';
    img.onload = () => {
      loaded += 1;
      if (loaded === items.length) {
        w.focus();
        w.print();
      }
    };
    img.src = dataUrl;
    cell.appendChild(img);

    const p = w.document.createElement('p');
    p.textContent = text;
    p.style.cssText = 'font-size:11px;text-align:center;margin:4px 0 0;';
    cell.appendChild(p);

    w.document.body.appendChild(cell);
  });

  return true;
};
